import { IIdentifiable } from '@/common/models/models'
import { ITag, Tag } from '@/common/models/data/dashboard/posts/tag'

interface ITagged extends IIdentifiable {
    tag_name: string
    tag_slug: string

    tag?: ITag
}

class Tagged implements ITagged {
    id = 0
    tag_name = ''
    tag_slug = ''

    tag = new Tag()

    constructor (dto?: ITagged) {
        if (dto) {
            this.id = dto.id
            this.tag_name = dto.tag_name
            this.tag_slug = dto.tag_slug

            this.tag = new Tag(dto.tag)
        }
    }
}

export {
    ITagged, Tagged
}
